import { render, staticRenderFns } from "./SocialECommerceLayout.vue?vue&type=template&id=14ac7fa8&scoped=true&"
import script from "./SocialECommerceLayout.vue?vue&type=script&lang=js&"
export * from "./SocialECommerceLayout.vue?vue&type=script&lang=js&"
import style0 from "./SocialECommerceLayout.vue?vue&type=style&index=0&id=14ac7fa8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ac7fa8",
  null
  
)

export default component.exports